module.exports = __webpack_public_path__ + "static/media/Notepad.d376ea2b.svg";